import { useEffect } from "react";

declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}

const PIXEL_ID = "1574519263146171";

export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window.fbq === "function") {
    window.fbq("track", eventName, params);
  }
};

const MetaPixel = () => {
  useEffect(() => {
    // Check if already loaded
    if (window.fbq) {
      return;
    }

    // Meta Pixel Base Code
    (function(f: any, b: Document, e: string, v: string, n?: any, t?: HTMLScriptElement, s?: Element) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s?.parentNode?.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

    // Initialize with Pixel ID
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
  }, []);

  return null;
};

export default MetaPixel;
